export enum Roles {
  Admin = 'Admin',
  Basic = 'Basic',
  Entry = 'Entry',
  PEP4 = 'PEP4'
}
